module.exports = __webpack_public_path__ + "img/Sibapp.6ef24ea5.svg";